export const amounts = {
  ft: 1,
  STARTER: 299,
  PRO: 999,
};
